import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { forumPostQueryOptions } from './useForumPost';

export const useDeleteForumPost = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/forum/posts/${id}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.removeQueries(forumPostQueryOptions(id));

      return queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
